import { render } from "./CollapseItem.vue?vue&type=template&id=e462ff36&scoped=true"
import script from "./CollapseItem.vue?vue&type=script&lang=js"
export * from "./CollapseItem.vue?vue&type=script&lang=js"

import "./CollapseItem.vue?vue&type=style&index=0&id=e462ff36&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e462ff36"]])

export default __exports__